import { UpdateItemResponse } from '@src/interface/api/response.interface'
import client from '../../client'
import { Refund } from '@src/type/refund'

export type ProcessRefundPayloadType = {
	paybackNo: string
	IdempotencyKey?: string
	amount?: number
	reason?: number
}

export const processRefund = async ({
	paybackNo,
	IdempotencyKey,
	amount,
	reason,
}: ProcessRefundPayloadType): Promise<UpdateItemResponse<Refund>> => {
	const body = {
		idempotency_key: IdempotencyKey,
		amount,
		reason,
	}
	const response = await client.post<UpdateItemResponse<Refund>>(
		`products/payback/${paybackNo}`,
		body,
	)

	return response.data
}
